
const infoPublic = {
  namespaced: true,
  state: {
    codes: '',
    PicfilesUrls:[],
    typePic:'',
    classTerminal:[],
    noticeData:'',
    PublishTaskInfo:'',
    val:'',
    treeListGroup:'',
    checkedArr:'',
    contList:[],
    picArr:[],
    fileSize: 0
  },
  mutations: {
    getCode(state, codes) {
      state.codes = codes
    },
    setPicfilesUrls (state, PicfilesUrls) { // 发布图片文件
      state.PicfilesUrls = PicfilesUrls;
    },
    settypePic (state, typePic) { // 类型
      state.typePic = typePic;
    },
    setFileSize (state, fileSize) { // 上传文件size
      state.fileSize = fileSize;
    },
    settypePicUp (state, picArr) { // 存到资源服务器数据
      state.picArr = picArr;
    },
    setclassTerminal (state, classTerminal) { // 是否是通知
      state.classTerminal = classTerminal;
    },
    setPublishTaskInfo (state, PublishTaskInfo) { // 是否是通知
      state.PublishTaskInfo = PublishTaskInfo;
    },
    setnoticeData (state, noticeData) { // 
      state.noticeData = noticeData;
    },
    setVal (state, val) { //
      state.val = val;
    },
    settreeListGroup (state, treeListGroup) { // 
      state.treeListGroup = treeListGroup;
    },
    setcheckedArr (state, checkedArr) { // 
      state.checkedArr = checkedArr;
    },
    setcontList (state, contList) { // 选择班牌
      state.contList = contList;
    },
    
    

  }
}
export default infoPublic